import {Component} from '@angular/core';
import {SampleSalesGrid} from '../SampleSalesGrid/SampleSalesGrid';
import {SampleRevenueChart} from '../SampleRevenueChart/SampleRevenueChart';
import {inject} from '@angular/core';
@Component({
	selector:'sales-dashboard',
	templateUrl:'./SalesDashboard.html',
	styles: [],
	styleUrls:['./SalesDashboard.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		SampleSalesGrid,
		SampleRevenueChart,
],
	standalone:true
})
export class SalesDashboard
{
	readonly sampleSalesGrid = inject(SampleSalesGrid);
	readonly sampleRevenueChart = inject(SampleRevenueChart);
}
